div.header {
	display: flex;
	gap: 20px;
	padding-right: 40px;
}

.headerInfo {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: 15px;
}

.titleRow {
	display: flex;
	align-items: center;
	gap: 8px;
}

p.description {
	font-size: 15px;
	font-weight: 400;
	color: #6b6b6b;
}
